import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface MasterStaysState {
    masterStays: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "find-all-stays" | null;
}

const initialState: MasterStaysState = {
    masterStays: null,
    loading: "idle",
    error: null,
    action: null,
};

// Thunk to fetch list of stays
export const getAllMasterStays = createAsyncThunk(
    "get/masterStays",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.MASTERS.FIND_ALL_STAYS, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Slice
const masterStaysSlice = createSlice({
    name: "masterStays",
    initialState,
    reducers: {
        resetAllStay: (state) => {
            state.loading = "idle";
            state.error = null;
            state.masterStays = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllMasterStays.pending, (state) => {
            state.loading = "pending";
            state.masterStays = null;
            state.error = null;
            state.action = "find-all-stays";
        });
        builder.addCase(getAllMasterStays.fulfilled, (state, action) => {
            state.loading = "fulfilled";
            state.masterStays = action.payload;
            state.error = null;
            state.action = "find-all-stays";
        });
        builder.addCase(getAllMasterStays.rejected, (state, action) => {
            state.loading = "rejected";
            state.error = action.payload as string;
            state.masterStays = null;
            state.action = "find-all-stays";
        });
    },
});

export const { resetAllStay } = masterStaysSlice.actions;
export default masterStaysSlice.reducer;
